import { createInstance, type i18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { getTQHostUrl } from 'utils/domains';

const localePath = process.env.REACT_APP_CYPRESS_BASE_URL
  ? `static/build/locales/{{lng}}/translation.json`
  : 'locales/{{lng}}/translation.json';

const tqI18N: i18n = createInstance();

tqI18N
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: 'all',
    backend: {
      loadPath: `${getTQHostUrl()}/${localePath}`,
    },
    lng: 'en-US',
    fallbackLng: 'en-US',
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default tqI18N;
